const DAY_IN_MS = 24 * 60 * 60 * 1000;

function shouldClearCart() {
  const lastTime = localStorage.getItem('lastCartTimestamp');
  const now = Date.now();

  if (!lastTime) {
    localStorage.setItem('lastCartTimestamp', now.toString());
    return false;
  }

  return now - Number(lastTime) >= DAY_IN_MS;
}

function clearCart() {
  return fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  }).then(response => {
    if (!response.ok) throw new Error('Failed to clear cart');
    return response.json();
  });
}

function checkAndClearCart() {
  const now = Date.now();

  return clearCart()
    .then(() => {
      localStorage.setItem('lastCartTimestamp', now.toString());
    })
    .catch(err => console.error('Error clearing cart:', err));
}

document.addEventListener('DOMContentLoaded', () => {
  if (shouldClearCart()) {
    checkAndClearCart();
  }

  setInterval(() => {
    if (shouldClearCart()) {
      checkAndClearCart();
    }
  }, 5 * 60 * 1000);
});
